export default __webpack_public_path__ + "static/media/payment.6ab61ca5.jpg";